import type { CoreNewsItemFragment } from "@/graphql";
import {
  Video_Provider,
  type DocumentFragment,
} from "@/graphql/generated-types";
import type { IMedia } from "@/interfaces";
import { toUnix } from "@/stories/utils/dates";

const toMediaVideo = (
  item: NonNullable<CoreNewsItemFragment["videos"]>[number],
): IMedia => {
  return {
    type: "video",
    url: item.url,
    title: item.description || "",
    provider: item.provider || Video_Provider.Youtube,
    thumbnail: item.thumbnail || "",
  };
};

export interface ICoreNewsDisplayItem {
  id?: string | number;
  title: string;
  description?: string;
  date: number;
  coverImage: string;
  isRead: boolean | null | undefined;
  isFeatured?: boolean;
  images?: string[];
  authorName?: string;
  authorImage?: string;
  authorTitle?: string;
  videos?: IMedia[];
  documents?: DocumentFragment[];
}

const toCoreNewsDisplayItem = (
  item: CoreNewsItemFragment,
): ICoreNewsDisplayItem => {
  const images = (item.pictures || []).map((item) => item.source);
  const firstImage = images.length ? images[0] : "";

  return {
    id: item.id,
    date: toUnix(item.showFrom),
    coverImage: item.image?.source || firstImage || "",
    isFeatured: item.isFeatured,
    images: images,
    videos: (item.videos || []).map(toMediaVideo),
    title: item.title,
    description: item.body,
    isRead: item.isRead,
    authorImage: item.author?.image?.source,
    authorName: item.author?.name,
    authorTitle: item.author?.title,
    documents: item.documents || [],
  };
};

export default {
  toCoreNewsDisplayItem,
};
